$(document).ready(function () {
  var startDate = $("#projectCountDown").data("start-at");

  $("#projectCountDown").countdown(startDate)
  .on('update.countdown', function(event) {
    if (event.offset.days >= 1) {
      $(this).text(event.strftime("%-D jours et %H heures"));
    } else {
      $(this).text(event.strftime("%H:%M:%S"));
    }
  })
  .on("finish.countdown", function(event) {
    $("#ongoingBlock, #notOngoingBlock").toggleClass("d-none");
  });
})
